import { render } from "./PatientLicensesCard.vue?vue&type=template&id=aac396f8"
import script from "./PatientLicensesCard.vue?vue&type=script&lang=js"
export * from "./PatientLicensesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__